import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { SharedConversationPage } from '@/components/AiAnalyst/SharedConversationPage'

/** Wiring only: the read-only view of a shared conversation. */
export const Route = createFileRoute('/_app/ai-analyst/shared/$conversationId')({
  component: SharedConversationIdRoute,
})

function SharedConversationIdRoute() {
  const { conversationId } = Route.useParams()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SharedConversationPage
      conversationId={conversationId}
      onStartOwn={() => void navigate({ to: '/ai-analyst' })}
      onOpenMine={(id) =>
        void navigate({ to: '/ai-analyst/c/$conversationId', params: { conversationId: id } })
      }
    />
  )
}
